"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const GoogleIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 18 18", style: svgStyle, xmlSpace: "preserve", fill: "currentColor" },
            React.createElement("g", { transform: "translate(1184.583 765.171)" },
                React.createElement("path", { d: "M-1175.4-757.8v3.5h4.8c-0.2,1.1-0.9,2.1-1.8,2.7l2.9,2.3c1.7-1.6,2.7-3.9,2.7-6.6c0-0.6-0.1-1.3-0.2-1.8 L-1175.4-757.8z", style: {
                        fill: "#4285F4"
                    } }),
                React.createElement("path", { d: "M-1180.4-754.5l-0.7,0.5l-2.3,1.8l0,0c1.5,2.9,4.5,5,8,5c2.4,0,4.5-0.8,6-2.2l-2.9-2.3c-0.8,0.5-1.8,0.9-3,0.9 C-1177.7-750.7-1179.7-752.3-1180.4-754.5L-1180.4-754.5z", style: {
                        fill: "#34A853"
                    } }),
                React.createElement("path", { d: "M-1183.4-760.2c-0.6,1.2-1,2.6-1,4c0,1.5,0.4,2.8,1,4c0,0,3-2.3,3-2.3c-0.2-0.5-0.3-1.1-0.3-1.7 s0.1-1.2,0.3-1.7L-1183.4-760.2z", style: {
                        fill: "#FBBC05"
                    } }),
                React.createElement("path", { d: "M-1175.4-761.6c1.3,0,2.5,0.5,3.4,1.3l2.6-2.6c-1.6-1.5-3.6-2.3-6-2.3c-3.5,0-6.6,2-8,5l3,2.3 C-1179.7-760-1177.7-761.6-1175.4-761.6L-1175.4-761.6z", style: {
                        fill: "#EA4335"
                    } })))));
};
GoogleIcon.displayName = 'GoogleIcon';
exports.default = GoogleIcon;
//# sourceMappingURL=GoogleIcon.js.map